<script setup lang="ts">
import { onMounted } from 'vue';
import { RouterLink } from 'vue-router';
import { useItemsStore } from '../stores/items';
const items = useItemsStore();
onMounted(() => items.init());
</script>

<template>
  <div class="mx-auto max-w-prose p-6 pt-safe">
    <RouterLink to="/" class="text-sm text-stone-400 underline">← К предметам</RouterLink>
    <h1 class="mt-4 text-2xl font-semibold">О проекте</h1>
    <p class="mt-3 text-stone-300">
      Мобильный браузерный справочник предметов
      <em>The Binding of Isaac (Repentance+)</em>.
    </p>
    <p class="mt-3 text-stone-300">
      Источник данных:
      <a class="underline" href="https://dead-god.ru/" target="_blank" rel="noopener">dead-god.ru</a>
      (WP REST API + ACF), дополнение —
      <a class="underline" href="https://isaac-items.ru/" target="_blank" rel="noopener">isaac-items.ru</a>.
    </p>
    <p class="mt-3 text-stone-300">
      База лежит локально в браузере как SQLite (WASM). Фильтрация и поиск
      работают без сети.
    </p>
    <p class="mt-3 text-xs text-stone-500" data-testid="db-source">
      Хранилище: {{ items.dbSource ?? 'инициализация…' }}
      <span v-if="items.dbSource === 'opfs'">(переживает перезагрузку)</span>
      <span v-else-if="items.dbSource === 'memfs'">(скачивается каждый раз)</span>
    </p>
  </div>
</template>
